<template>
	<div class="overlap-group-wrapper-subsections" :class="navbarClass">
		<div class="overlap-group-2" :class="navbarClass">


			<div class="navbar" @mouseleave="handleMouseLeave">
				<img class="logo" style="position: absolute;left: -210px;" alt="Logo" :src="getHoverClass()" />

				<div style="cursor: pointer;" class="text-wrapper-12" :class="getHoverClass(0)" @click="navigateTohome"
					@mouseover="handleMouseOver(0)">
					<div class="liness" :class="getHoverClassborder(0)"></div>
					<div :class="navbartextclass(0)">首页</div>
				</div>

				<div class="text-wrapper-13" :class="getHoverClass(1)" @mouseover="handleMouseOver(1)"
					@click="navigateToAboutUs" style="cursor: pointer;">
					<div class="liness"  :class="getHoverClassborder(1)"></div>
					<div :class="navbartextclass(1)">关于朗乾</div>
				</div>

				<div class="text-wrapper-14" :class="getHoverClass(2)" @mouseover="handleMouseOver(2)"
					@click="navigateToJoinUs" style="cursor: pointer;">
					<div class="liness" :class="getHoverClassborder(2)"></div>
					<div :class="navbartextclass(2)">优才招聘</div>
				</div>

				<div class="text-wrapper-15" :class="getHoverClass(3)" @mouseover="handleMouseOver(3)"
					@click="navigateToTeamSpotlight" style="cursor: pointer;">
					<div class="liness" :class="getHoverClassborder(3)"></div>
					<div :class="navbartextclass(3)">团队风采</div>
				</div>

				<div class="text-wrapper-16" :class="getHoverClass(4)" @mouseover="handleMouseOver(4)"
					@click="navigateToNewsUpdates" style="cursor: pointer;">
					<div class="liness" :class="getHoverClassborder(4)"></div>
					<div :class="navbartextclass(4)">新闻资讯</div>
				</div>

				<div class="text-wrapper-17" :class="getHoverClass(5)" @mouseover="handleMouseOver(5)"
					@click="navigateToPartyBuilding" style="cursor: pointer;">
					<div class="liness" :class="getHoverClassborder(5)"></div>
					<div :class="navbartextclass(5)">党建信息</div>
				</div>

				<div class="text-wrapper-18" :class="getHoverClass(6)" @mouseover="handleMouseOver(6)"
					@click="navigateToContactUs" style="cursor: pointer;">
					<div class="liness" :class="getHoverClassborder(6)"></div>
					<div :class="navbartextclass(6)">联系我们</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import router from '../router';

	export default {
		name: "Header",
		data() {
			return {
				hoverIndex: -1, // 当前悬停项
				lastHoverIndex: 0 // 最近一次悬停项，默认首页高亮
			}
		},
		props: {
			currentRoute: {
				type: String,
				required: true
			}
		},
		watch: {
		  '$route.path'(newPath) {
		      this.updateLastHoverIndexByPath(newPath);
		    }
		},
		mounted() {
			this.updateLastHoverIndexByPath(this.$route.path);
		},
		computed: {

			// 根据传入的 currentRoute 判断是否修改样式
			navbarClass() {
				let x = ''
				// console.log('Current route:', this.currentRoute);
				if (this.currentRoute === '/') {
					x = 'home_sbai'
				}
				return x; // 默认样式
			},
			// 根据传入的 currentRoute 判断是否修改样式
// 			navbartextclass() {
// 				let x = ''
// 				// console.log('Current route:', this.currentRoute);
// 				if (this.currentRoute === '/') {
// 					x = 'navbartext'
// 				}
// 				return x; // 默认样式
// 			},
			
			
		navbartextclass() {
    return (index) => {
        if (this.currentRoute === '/') {
            return 'navbartext'; // 首页时文字颜色为白色
        } else {
            return (this.hoverIndex === index || (this.hoverIndex === -1 && this.lastHoverIndex === index)) ?
                'navbartext_hover' : 'navbartext_non_home'; // 非首页时，未被选中或悬停的文字颜色
        }
    }
},
			
			navbarClasstext() {
				let x = ''
				// console.log('Current route:', this.currentRoute);
				if (this.currentRoute === '/') {
					x = 'navbartext'
				}
				return x; // 默认样式
			}
		},
		methods: {
			updateLastHoverIndexByPath(path) {
			    switch(path){
			      case '/': this.lastHoverIndex = 0; break;
			      case '/about': this.lastHoverIndex = 1; break;
			      case '/JoinUsPage': this.lastHoverIndex = 2; break;
			      case '/TeamSpotlightPage': this.lastHoverIndex = 3; break;
			      case '/NewsUpdatesPage': this.lastHoverIndex = 4; break;
			      case '/PartyBuildingPage': this.lastHoverIndex = 5; break;
			      case '/ContactUsPage': this.lastHoverIndex = 6; break;
			      default: this.lastHoverIndex = -1;
			    }
			  },
			
			handleMouseOver(index) {
				this.hoverIndex = index;
				this.lastHoverIndex = index;
			},
			handleMouseLeave() {
				this.hoverIndex = -1;
			},
			getHoverClass(index) {
				let x = ''
				if (this.currentRoute === '/') {
					return '/img/logos.png'
				} else {
					return '/img/logo1-1.png'
				}

			},
			getHoverClassborder(index){
				let x = ''
				if (this.currentRoute === '/') {
					return (this.hoverIndex === index || (this.hoverIndex === -1 && this.lastHoverIndex === index)) ?
						'linessone' : '';
				} else {
					return (this.hoverIndex === index || (this.hoverIndex === -1 && this.lastHoverIndex === index)) ?
						'liness_hover' : '';
				}
			},
			
			getimgsrc(index){
				let x = ''
				if (this.currentRoute === '/') {
					return (this.hoverIndex === index || (this.hoverIndex === -1 && this.lastHoverIndex === index)) ?
						'linessone' : '';
				} else {
					return (this.hoverIndex === index || (this.hoverIndex === -1 && this.lastHoverIndex === index)) ?
						'liness_hover' : '';
				}
			},
			navigateToAboutUs() {
				router.push({
					path: '/about'
				})
			},
			navigateTohome() {
				router.push({
					path: '/'
				})
			},
			navigateToNewsUpdates() {
				router.push({
					path: '/NewsUpdatesPage'
				})
			},
			navigateToPartyBuilding() {
				router.push({
					path: '/PartyBuildingPage'
				})
			},
			navigateToContactUs() {
				router.push({
					path: '/ContactUsPage'
				})
			},
			navigateToJoinUs() {
				router.push({
					path: '/JoinUsPage'
				})
			},
			navigateToTeamSpotlight() {
				router.push({
					path: '/TeamSpotlightPage'
				})
			}
		}
	};
</script>

<style>
	.navbartext {
		color: #fff;
	}
	
	.navbartext_non_home {
    color: #333333; /* 非首页时，未被选中或悬停的文字颜色 */
}
	
	.navbartext_hover {
    color: #7A3529;
}

	.home_sbai {
		background-color: transparent !important;
	}

	.hover_ment {
		/* background-color: red; */

		
		/* border-color: #fff !important; */
		color: #fff;
	
	}

	.hover_ments {
		/* background-color: red; */
		/* border-top: 3px solid #997c74 !important; */
		color: #7A3529;
	
	}
	.liness {
	  width: 24px;
	  height: 4px;
	  /* background-color: #997c74; */
	  margin: auto;
	  margin-top: -10px;
	  margin-bottom: 10px;
	}
	.liness_hover {
	  width: 24px;
	  height: 4px;
	  background-color: #7A3529;
	  margin: auto;
	  margin-top: -10px;
	  margin-bottom: 10px;
	}
	
	.linessone {
	  width: 24px;
	  height: 4px;
	  background-color: #ffffff;
	  margin: auto;
	  margin-top: -10px;
	  margin-bottom: 10px;
	}

	.overlap-group-wrapper-subsections {
		z-index: 99999;
		height: 60px;
		left: 0;
		position: fixed;
		top: 0;
		width: 100%;
		background-color: #ffffff;

		display: flex;
		justify-content: center;
	}

	.overlap-group-wrapper-subsections .logo {
		height: 41px;
		left: 0;
		position: absolute;
		top: 12px;
		width: 175px;
	}

	.overlap-group-wrapper-subsections .overlap-group-2 {
		/* height: 651px; */
		position: relative;
		width: 1208px;
	}

	.overlap-group-wrapper-subsections .rectangle-wrapper {
		background-image: url(/img/rectangle-10.png);
		background-position: 50% 50%;
		background-size: cover;
		height: 651px;
		left: 0;
		position: absolute;
		top: 0;
		width: 1208px;
	}

	.overlap-group-wrapper-subsections .rectangle {
		background-color: #380c0c4c;
		height: 651px;
	}

	.overlap-group-wrapper-subsections .text-wrapper-9 {
		color: #ffffff;
		font-family: "PingFang SC-Semibold", Helvetica;
		font-size: 42px;
		font-weight: 400;
		left: 74px;
		letter-spacing: 11.34px;
		line-height: normal;
		position: absolute;
		top: 121px;
	}

	.overlap-group-wrapper-subsections .text-wrapper-10 {
		color: #ffffff;
		font-family: "PingFang SC-Medium", Helvetica;
		font-size: 22px;
		font-weight: 500;
		left: 74px;
		letter-spacing: 2.64px;
		line-height: normal;
		position: absolute;
		top: 207px;
	}

	.overlap-group-wrapper-subsections .langqian-law-firm-a {
		color: #ffffff;
		font-family: "PingFang SC-Medium", Helvetica;
		font-size: 20px;
		font-weight: 500;
		left: 75px;
		letter-spacing: 0.60px;
		line-height: normal;
		position: absolute;
		top: 271px;
	}

	.overlap-group-wrapper-subsections .line {
		height: 1px;
		left: 75px;
		object-fit: cover;
		position: absolute;
		top: 190px;
		width: 199px;
	}

	.overlap-group-wrapper-subsections .rectangle-2 {
		background-color: #7a3529;
		height: 40px;
		left: 74px;
		position: absolute;
		top: 397px;
		width: 120px;
	}

	.overlap-group-wrapper-subsections .text-wrapper-11 {
		color: #ffffff;
		font-family: "PingFang SC-Semibold", Helvetica;
		font-size: 18px;
		font-weight: 400;
		left: 94px;
		letter-spacing: 2.70px;
		line-height: normal;
		position: absolute;
		top: 404px;
	}

	.overlap-group-wrapper-subsections .navbar {
		height: 40px;
		left: 295px;
		position: absolute;
		top: 0;
		width: 702px;
	}

	.overlap-group-wrapper-subsections .rectangle-3 {
		background-color: #ffffff;
		height: 4px;
		left: 2px;
		position: absolute;
		top: 0;
		width: 24px;
	}

	.overlap-group-wrapper-subsections .text-wrapper-12 {
		border-top: 3px solid transparent;
padding-top: 10px !important;
		font-family: "PingFang SC-Medium", Helvetica;
		font-size: 14px;
		left: 0;
		letter-spacing: 0;
		line-height: normal;
		position: absolute;
		top: 4px;
	}

	.overlap-group-wrapper-subsections .text-wrapper-13 {
		border-top: 3px solid transparent;
		padding-top: 10px !important;
		font-family: "PingFang SC-Medium", Helvetica;
		font-size: 14px;
		left: 82px;
		letter-spacing: 0;
		line-height: normal;
		position: absolute;
		top: 4px;
	}

	.overlap-group-wrapper-subsections .text-wrapper-14 {
		border-top: 3px solid transparent;
		padding-top: 10px !important;
		font-family: "PingFang SC-Medium", Helvetica;
		font-size: 14px;
		left: 522px;
		letter-spacing: 0;
		line-height: normal;
		position: absolute;
		top: 4px;
	}

	.overlap-group-wrapper-subsections .text-wrapper-15 {
		border-top: 3px solid transparent;
		padding-top: 10px !important;
		font-family: "PingFang SC-Medium", Helvetica;
		font-size: 14px;
		left: 192px;
		letter-spacing: 0;
		line-height: normal;
		position: absolute;
		top: 4px;
	}

	.overlap-group-wrapper-subsections .text-wrapper-16 {
		border-top: 3px solid transparent;
		padding-top: 10px !important;
		font-family: "PingFang SC-Medium", Helvetica;
		font-size: 14px;
		left: 302px;
		letter-spacing: 0;
		line-height: normal;
		position: absolute;
		top: 4px;
	}

	.overlap-group-wrapper-subsections .text-wrapper-17 {
		border-top: 3px solid transparent;
		padding-top: 10px !important;
		font-family: "PingFang SC-Medium", Helvetica;
		font-size: 14px;
		left: 412px;
		letter-spacing: 0;
		line-height: normal;
		position: absolute;
		top: 4px;
	}

	.overlap-group-wrapper-subsections .text-wrapper-18 {
		border-top: 3px solid transparent;
		padding-top: 10px !important;
		font-family: "PingFang SC-Medium", Helvetica;
		font-size: 14px;
		left: 632px;
		letter-spacing: 0;
		line-height: normal;
		position: absolute;
		top: 4px;
	}
</style>